import { DOWNTIME_BG, rangeGeometry } from "./ganttUtils";

export function DowntimeBlock({ downtime: dt, winStart, winEnd }) {
  const g = rangeGeometry(dt.start_time, dt.end_time, winStart, winEnd);
  if (!g) return null;
  return (
    <div
      className="absolute inset-y-0 border-x border-red-300/60 flex items-end justify-center"
      style={{ left: `${g.left}%`, width: `${g.width}%`, background: DOWNTIME_BG }}
      title={`Downtime: ${dt.reason}\n${new Date(dt.start_time).toLocaleString("en-IN")} → ${new Date(dt.end_time).toLocaleString("en-IN")}`}
      data-testid="gantt-downtime-block"
    >
      {g.width > 6 && (
        <span className="mb-0.5 text-[9px] font-mono-data uppercase tracking-wide text-red-500/90 truncate px-1">{dt.reason}</span>
      )}
    </div>
  );
}
